export const ENTITY_DIALOG_REDUCER_KEY = 'entityDialog';

export const ENTITY_DIALOG_COMPONENT_NAMES = {
  ADD_DEVICE: 'addDevice',
  ADD_USER: 'addUser',
  ADD_BLT_ENTITY: 'addBLTEntity',
  CONFIGURE_BLT_ENTITY: 'configureBLTEntity',
  ADD_BLT_ROOM: 'addBLTRoom',
  CHANGE_OWNER: 'changeOwner',
  ADD_RELATIVE: 'addRelative',
  CHANGE_SUPERVISOR: 'changeSupervisor',
  SHOW_DEVICE_MONITORING: 'showDeviceMonitoring',
  SHOW_LOCATION_POPOVER: 'showLocationPopover',
  SHOW_OVERVIEW_POPOVER: 'showOverviewPopover',
  SHOW_CONFIG_POPOVER: 'showConfigPopover',
  ADD_COMPANY_POPOVER: 'addCompanyPopover',
  ADD_BRANCH_POPOVER: 'addBranchPopover',
  ADD_DEVICE_POPOVER: 'addDevicePopover',
  SALES_DASHBOARD_POPOVER: 'salesDashboardPopover',
  MARK_ALERTS_DONE_FORM: 'markAlertsDoneForm',
  CLONE_DEVICES: 'cloneDevices'
};
